export enum ProjectAccessRulesKeyEnum {
  // --- Модуль PROJECT (Задачи) ---
  // --- Раздел PROJECT.SECTIONS.PROJECT (Задачи) ---

  // Вкладка "Задачи"
  PROJECT_PROJECT_TASK_READ = 'PROJECT_PROJECT_TASK_READ',
  PROJECT_PROJECT_TASK_WRITE = 'PROJECT_PROJECT_TASK_WRITE',

  // Вкладка "Календарь событий"
  PROJECT_PROJECT_EVENT_CALENDAR_READ = 'PROJECT_PROJECT_EVENT_CALENDAR_READ',
  PROJECT_PROJECT_EVENT_CALENDAR_WRITE = 'PROJECT_PROJECT_EVENT_CALENDAR_WRITE',

  // Вкладка "Трудозатраты"
  PROJECT_PROJECT_TIME_REPORT_READ = 'PROJECT_PROJECT_TIME_REPORT_READ',

  // Вкладка "Шаблоны"
  PROJECT_PROJECT_TEMPLATE_READ = 'PROJECT_PROJECT_TEMPLATE_READ',
  PROJECT_PROJECT_TEMPLATE_WRITE = 'PROJECT_PROJECT_TEMPLATE_WRITE',

  // Разрешения
  PROJECT_PROJECT_CAN_READ_ALL_PROJECTS = 'PROJECT_PROJECT_CAN_READ_ALL_PROJECTS',
  PROJECT_PROJECT_DELETE_OTHER_USER_COMMENTS = 'PROJECT_PROJECT_DELETE_OTHER_USER_COMMENTS',
}
